module.exports = __webpack_public_path__ + "img/cloth_g3_item-04.7f04c270.svg";